<div #resizeBox [ngClass]="mainChatBoxClass">
  <span #dragHandleCorner class="dragHandle corner" cdkDrag [cdkDragDisabled]="isMaximixedChatWindow"
    (cdkDragMoved)="dragMove(dragHandleCorner, $event)"></span>
  <span #dragHandleRight cdkDragLockAxis="x" class="dragHandle" [ngClass]="{ right: isMaximixedChatWindow }" cdkDrag
    [cdkDragDisabled]="!isMaximixedChatWindow" (cdkDragMoved)="dragMove(dragHandleRight, $event)"></span>
  <!--
    <span #dragHandleTop cdkDragLockAxis="y" class="dragHandle top" cdkDrag (cdkDragMoved)="dragMove(dragHandleTop, $event)"></span>
    -->

  <ion-toolbar class="toolbar-color-custom" [ngClass]="topHeaderChatBoxClass">
    @if (!isMaximixedChatWindow) {
    <ion-buttons slot="start">
      <ion-button matTooltip="{{ 'Etiqueta._Chat_Reset_Size' | translate }}" matTooltipPosition="below"
        class="no-ripple" (click)="resetChatDimensions()">
        <ion-icon name="expand-outline" class="icon-color-custom"> </ion-icon>
      </ion-button>
    </ion-buttons>
    }
    <ion-buttons slot="start">
      @if (!isMaximixedChatWindow) {
      <ion-button matTooltip="{{ 'Etiqueta._Chat_Maximixed_Size' | translate }}" matTooltipPosition="below"
        class="no-ripple" (click)="openModalMaximizedChat()">
        <ion-icon name="open-outline" class="icon-color-custom ion-img-transformation-flip-horizontal">
        </ion-icon>
      </ion-button>
      } @else {
      <ion-button matTooltip="{{ 'Etiqueta._Chat_Minimize_Size' | translate }}" matTooltipPosition="below"
        class="no-ripple" (click)="closeModalMaximizedChat()">
        <ion-icon name="open-outline"
          class="icon-color-custom ion-img-transformation-flip-horizontal ion-img-transformation-flip-vertical">
        </ion-icon>
      </ion-button>
      }
    </ion-buttons>
    <ion-title>Quantron</ion-title>
    <ion-buttons slot="end">
      <ion-icon size="large" name="pie-chart-sharp" class="icon-color-custom ion-padding-end-8"></ion-icon>
      <ion-toggle id="toggle-trigger" color="tech-blue" class="switch-input" [(ngModel)]="chartsIsEnabled">
      </ion-toggle>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="no-ripple" (click)="closeModal()">
        <ion-icon name="close" class="icon-color-custom"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-popover class="chat-ai-charts-popover" trigger="toggle-trigger" triggerAction="click" side="bottom"
      alignment="start" showBackdrop="false">
      <ng-template>
        <ion-item class="item-color-custom" lines="none">
          <ion-label class="ion-text-wrap ion-font-alliance-regular ion-text-center">
            @if (chartsIsEnabled) {
            {{ "Etiqueta._Chat_Charts_Enabled" | translate }}
            } @else {
            {{ "Etiqueta._Chat_Charts_Disabled" | translate }}
            }
          </ion-label>
        </ion-item>
      </ng-template>
    </ion-popover>
  </ion-toolbar>

  <div class="chat-container scroll-content-custom-color">
    <div class="messages-container" #messagesContainer>
      @for (message of messages; track message) {
      <div class="message" [ngClass]="{'user-message': message.isUser,'ai-message': !message.isUser,}">
        <div class="message-bubble">
          @if (message.text.length > 0) {
          <p [innerHTML]="message.text"></p>
          } @else {
          @if (hasErrorQuantronResponse()) {
          <p class="p-container">
            {{ message.htmlMessageDetail.minResumeHtml }}
          </p>
          } @else {
          <div class="p-container">

            <ion-grid class="ion-no-padding">
              <ion-row>
                @if(message.htmlMessageDetail.dataIsVisible) {
                <ion-col [size]="chatCurrentWidth >= 750 ? 4 : chatCurrentWidth >= 500 ? 6 : 12" class="ion-padding-5">
                  <div class="message-section-box box-clickable"
                    [ngClass]="{'chat-container-fill-height': chatCurrentWidth > 500}"
                    (click)="assignCompleteTableDetail(message.messageKey)">
                    <ion-grid class="ion-no-padding">
                      <ion-row class="ion-justify-content-center ion-align-items-center">
                        <ion-col size="6">
                          <span class="title-card">DATA</span>
                        </ion-col>

                        <ion-col size="6" class="ion-text-end">
                          <span class="message-section-bubble-box"
                            [ngClass]="{'loading-bubble': message.htmlMessageDetail.dataCardStatus === 0, 'ready-bubble': message.htmlMessageDetail.dataCardStatus === 2 }">
                            @switch (message.htmlMessageDetail.dataCardStatus) {
                            @case (0) {
                            <ion-icon slot="start" name="hourglass-outline" color="loading-yellow"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (1) {
                            <ion-icon slot="start" name="flash-outline" color="fast-blue"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (2) {
                            <ion-icon slot="start" name="checkmark-circle-outline" color="ready-green"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            }
                            <ion-label
                              [color]="message.htmlMessageDetail.dataCardStatus > 0 ? 'ready-green' : 'loading-yellow'"
                              class="status-title-card">
                              {{ message.htmlMessageDetail.dataCardStatus > 0 ? 'Ready' : 'Processing' }}
                            </ion-label>
                          </span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>

                    <div class="section-divider-box"></div>

                    @if(!message.htmlMessageDetail.dataShown) {
                    <ion-row class="ion-justify-content-center">
                      <ion-col size="12" class="ion-text-center">
                        <ion-spinner name="crescent" color="tech-blue"></ion-spinner>
                      </ion-col>
                      <ion-col size="12" class="ion-text-center">
                        <span class="loading-message-card">Querying data sources...</span>
                      </ion-col>
                    </ion-row>

                    } @else {
                    @if(message.htmlMessageDetail.minFinanceTableResumeHtml.length > 0) {
                    <ion-grid class="ion-no-padding ion-margin-top-8">
                      <ion-row class="ion-justify-content-center ion-align-items-center">
                        <ion-col size="12">
                          <span class="finance-data-title-card">
                            Financial
                          </span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>

                    <div class="table-container finance-table box-clickable">
                      <p (click)="assignTableDetail($event, message.messageKey, 'Finance')"
                        [innerHTML]="message.htmlMessageDetail.minFinanceTableResumeHtml"></p>
                    </div>
                    }

                    @if(message.htmlMessageDetail.minOperationsTableResumeHtml.length > 0) {
                    <ion-grid class="ion-no-padding ion-margin-top-8">
                      <ion-row class="ion-justify-content-center ion-align-items-center">
                        <ion-col size="12">
                          <span class="operations-data-title-card">
                            Operations
                          </span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>

                    <div class="table-container operations-table box-clickable">
                      <p [innerHTML]="message.htmlMessageDetail.minOperationsTableResumeHtml"
                        (click)="assignTableDetail($event, message.messageKey, 'Operations')"></p>
                    </div>
                    }

                    @if(message.htmlMessageDetail.minFinanceTableResumeHtml.length === 0 &&
                    message.htmlMessageDetail.minOperationsTableResumeHtml.length === 0) {
                    <ion-row class="ion-justify-content-center">
                      <ion-col size="12" class="ion-text-center">
                        <span class="loading-message-card">{{ 'Etiqueta.Vacio._Chat_Data' | translate }}</span>
                      </ion-col>
                    </ion-row>
                    }

                    }
                  </div>
                </ion-col>
                }

                @if(message.htmlMessageDetail.insightsIsVisible) {
                <ion-col [size]="chatCurrentWidth >= 750 ? 4 : chatCurrentWidth >= 500 ? 6 : 12" class="ion-padding-5">
                  <div class="message-section-box-insight box-clickable">
                    <ion-grid class="ion-no-padding">
                      <ion-row class="ion-justify-content-center ion-align-items-center">
                        <ion-col size="6">
                          <span class="title-card">ANALYSIS</span>
                        </ion-col>

                        <ion-col size="6" class="ion-text-end">
                          <span class="message-section-bubble-box"
                            [ngClass]="{'loading-bubble': message.htmlMessageDetail.insightsCardStatus === 0, 'fast-bubble': message.htmlMessageDetail.insightsCardStatus === 1, 'ready-bubble': message.htmlMessageDetail.insightsCardStatus === 2 }">
                            @switch (message.htmlMessageDetail.insightsCardStatus) {
                            @case (0) {
                            <ion-icon slot="start" name="hourglass-outline" color="loading-yellow"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (1) {
                            <ion-icon slot="start" name="flash-outline" color="fast-blue"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (2) {
                            <ion-icon slot="start" name="checkmark-circle-outline" color="ready-green"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            }
                            <ion-label
                              [color]="message.htmlMessageDetail.insightsCardStatus >= 2 ? 'ready-green' : message.htmlMessageDetail.insightsCardStatus === 1 ? 'fast-blue' : 'loading-yellow'"
                              class="status-title-card">
                              {{ message.htmlMessageDetail.insightsCardStatus >= 2 ? 'Ready' : message.htmlMessageDetail.insightsCardStatus === 1 ? 'Quick View' : 'Processing' }}
                            </ion-label>
                          </span>
                        </ion-col>

                      </ion-row>
                    </ion-grid>

                    <div class="section-divider-box"></div>

                    @if(!message.htmlMessageDetail.insightsCompleteShown &&
                    !message.htmlMessageDetail.insightsFastShown) {
                    <ion-row class="ion-justify-content-center">
                      <ion-col size="12" class="ion-text-center">
                        <ion-spinner name="crescent" color="tech-blue"></ion-spinner>
                      </ion-col>
                      <ion-col size="12" class="ion-text-center">
                        <span class="loading-message-card">Analyzing data...</span>
                      </ion-col>
                    </ion-row>

                    } @else {
                    <p [innerHTML]="message.htmlMessageDetail.minResumeHtml"
                      (click)="openModalResumeDetail(message.messageKey)"></p>
                    }
                  </div>
                </ion-col>
                }

                @if(message.htmlMessageDetail.chartsIsVisible) {
                <ion-col [size]="chatCurrentWidth >= 750 ? 4 : chatCurrentWidth >= 500 ? 6 : 12" class="ion-padding-5">
                  <div class="message-section-box box-clickable"
                    [ngClass]="{'chat-container-fill-height': chatCurrentWidth > 750}"
                    (click)="openModalCompleteMinitureChartDetail(message.messageKey)">
                    <ion-grid class="ion-no-padding">
                      <ion-row class="ion-justify-content-center ion-align-items-center">
                        <ion-col size="6">
                          <span class="title-card">GRAPHS</span>
                        </ion-col>

                        <ion-col size="6" class="ion-text-end">
                          <span class="message-section-bubble-box"
                            [ngClass]="{'loading-bubble': message.htmlMessageDetail.chartsCardStatus === 0, 'fast-bubble': message.htmlMessageDetail.chartsCardStatus === 1, 'ready-bubble': message.htmlMessageDetail.chartsCardStatus === 2 }">
                            @switch (message.htmlMessageDetail.chartsCardStatus) {
                            @case (0) {
                            <ion-icon slot="start" name="hourglass-outline" color="loading-yellow"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (1) {
                            <ion-icon slot="start" name="flash-outline" color="fast-blue"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            @case (2) {
                            <ion-icon slot="start" name="checkmark-circle-outline" color="ready-green"
                              class="ion-icon-status-card-chat-center"></ion-icon>
                            }
                            }
                            <ion-label
                              [color]="message.htmlMessageDetail.chartsCardStatus >= 2 ? 'ready-green' : message.htmlMessageDetail.chartsCardStatus === 1 ? 'fast-blue' : 'loading-yellow'"
                              class="status-title-card">
                              {{ message.htmlMessageDetail.chartsCardStatus >= 2 ? 'Ready' : message.htmlMessageDetail.chartsCardStatus === 1 ? 'Quick View' : 'Processing' }}
                            </ion-label>
                          </span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>

                    <div class="section-divider-box"></div>

                    @if(!message.htmlMessageDetail.chartsCompleteShown &&
                    !message.htmlMessageDetail.chartsFastShown) {

                    <ion-row class="ion-justify-content-center">
                      <ion-col size="12" class="ion-text-center">
                        <ion-spinner name="crescent" color="tech-blue"></ion-spinner>
                      </ion-col>
                      <ion-col size="12" class="ion-text-center">
                        <span class="loading-message-card">Generating graphs...</span>
                      </ion-col>
                    </ion-row>

                    } @else {
                    @if (message.htmlMessageDetail.charts.length > 0) {
                    <div class="box-chart-container">
                      <ion-grid class="ion-no-padding">
                        <ion-row class="ion-justify-content-center">
                          @for ( chart of message.htmlMessageDetail.charts; track chart; let idx = $index ) {
                          @if(idx >= 4) {
                          <ion-col size="12" class="ion-text-left">
                            <span class="loading-message-card">+{{ idx - 4 }} más</span>
                          </ion-col>
                          } @else {
                          <ion-col size="6" class="ion-padding-3">
                            <div class="chart-container">
                              <img [alt]="'Etiqueta._Graficas' | translate" [src]="'data:image/png;base64,' + chart.chart_base64"
                                class="img-chart-ai box-clickable"
                                (click)="openModalChartDetail($event, message.messageKey, idx)" />
                            </div>
                          </ion-col>
                          }
                          }
                        </ion-row>
                      </ion-grid>
                    </div>
                    }

                    @if(message.htmlMessageDetail.charts.length === 0) {
                    <ion-row class="ion-justify-content-center">
                      <ion-col size="12" class="ion-text-center">
                        <span class="loading-message-card">{{ 'Etiqueta.Vacio._Chat_Charts' | translate }}</span>
                      </ion-col>
                    </ion-row>
                    }
                    }
                  </div>
                </ion-col>
                }
              </ion-row>
            </ion-grid>

          </div>
          }
          }

          <span class="timestamp">
            {{ message.timestamp | date: "short" }}
          </span>
        </div>
      </div>
      }

      @if (isTyping()) {
      <div class="message ai-message">
        <div class="message-bubble typing">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <ion-toolbar class="toolbar-color-custom" [ngClass]="bottomHeaderChatBoxClass">
    <div class="input-container">
      <ion-item class="item-color-custom" lines="none">
        <ion-input class="input-msg-color-custom" [(ngModel)]="newMessage"
          placeholder="{{ 'Etiqueta._Chat_Pregunta_Inpt' | translate }}" (keyup.enter)="sendMessage()"
          [disabled]="isTyping()">
        </ion-input>
        <ion-button slot="end" fill="clear" (click)="sendMessage()" [disabled]="!newMessage.trim() || isTyping()">
          <ion-icon color="tech-blue" name="send"></ion-icon>
        </ion-button>
      </ion-item>
    </div>
  </ion-toolbar>

  <div class="over-quantron" [ngClass]="{ 'invert-quantron-position': isMaximixedChatWindow }">
    <img alt="" src="../../../assets/imgs/mascot-chat.png" />
  </div>
</div>
@if (isMaximixedChatWindow) {
<div #sideChatDetailsBox class="modal-side-chat-details maximixed-chat-right-side-border">
  <div class="m-modal ion-top-right-border-rounded-x10 ion-bottom-right-border-rounded-x10">
    <ion-grid class="ion-padding">
      <ion-row class="m-modal-header">
        <ion-col size="6" size-md="11">
          @if (maximixedModalView() !== "Welcome") {
          <h4 class="m-modal-title">{{ sideModalTitle() }}</h4>
          }
        </ion-col>
        <ion-col size="6" size-md="1" class="ion-text-center">
          <ion-button matTooltip="{{ 'Etiqueta._Chat_Clean_Side_Panel' | translate }}" matTooltipPosition="below"
            color="tech-blue" class="m-modal-icon" fill="clear" (click)="clearSideModalView()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>

      @if (maximixedModalView() === "Welcome") {
      <ion-row class="m-modal-header ion-justify-content-center ion-padding-top-30">
        <ion-col size="12" class="ion-text-center">
          <h4 class="m-modal-title">📋 Panel de Detalles</h4>
        </ion-col>
      </ion-row>
      <ion-row class="m-modal-header ion-justify-content-center">
        <ion-col size="12" class="ion-text-center">
          <p class="m-modal-sub-title">
            Haz clic en cualquier elemento del chat para ver los detalles
            aquí
          </p>
        </ion-col>
      </ion-row>
      } @else {
      <ion-row class="m-modal-body m-modal-maximixed-view scroll-content-custom-color">
        <ion-col size="12">
          <ion-list class="m-modal-field-list list-color-custom">
            @if (maximixedModalView() === "Resume" || maximixedModalView() === "Full") {
            <p class="insights-full" [innerHTML]="resumeDetail"></p>
            }

            @if (maximixedModalView() === "TableFinance" || maximixedModalView() === "TableComplete") {
            @if(tableFinanceDetail.length > 0) {
            <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30">
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-justify-content-end">
                  <ion-col size="auto" class="ion-no-padding">
                    <ion-button expand="block" size="small" fill="clear" color="stone-gray"
                      class="bar-btn-custom no-ripple" (click)="onParseDataToExcelFile('Financial')"
                      matTooltip="Exportar Financial">
                      <ion-icon slot="start" [src]="'/assets/imgs/icons/export-table.svg'"
                      class="icon-color-custom-svg ion-icon-svg-export-table"></ion-icon>
                      {{ 'Boton._Exportar' | translate }}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>

              @if(maximixedModalView() === "TableComplete") {
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-align-items-center">
                  <ion-col size="12">
                    <h4 class="m-modal-subtitle-financial">Financial</h4>
                  </ion-col>
                </ion-row>
              </ion-grid>
              }

              <p class="table-container" [innerHTML]="tableFinanceDetail"></p>
            </div>
            }
            }

            @if (maximixedModalView() === "TableOperations" || maximixedModalView() === "TableComplete") {
            @if(tableOperationsDetail.length > 0) {
            <div class="ion-padding ion-padding-top-0 ion-padding-bottom-8 ion-margin-bottom-30">
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-justify-content-end">
                  <ion-col size="auto" class="ion-no-padding">
                    <ion-button expand="block" size="small" fill="clear" color="stone-gray"
                      class="bar-btn-custom no-ripple" (click)="onParseDataToExcelFile('Operations')"
                      matTooltip="Exportar Operations">
                      <ion-icon slot="start" [src]="'/assets/imgs/icons/export-table.svg'"
                      class="icon-color-custom-svg ion-icon-svg-export-table"></ion-icon>
                      {{ 'Boton._Exportar' | translate }}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </ion-grid>

              @if(maximixedModalView() === "TableComplete") {
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-align-items-center">
                  <ion-col size="12">
                    <h4 class="m-modal-subtitle-operations">Operations</h4>
                  </ion-col>
                </ion-row>
              </ion-grid>
              }

              <p class="table-container" [innerHTML]="tableOperationsDetail"></p>
            </div>
            }
            }

            @if (maximixedModalView() === "Chart") {
            @if (chartsDetail.length > 0) {
            <div class="ion-padding-start-8 ion-padding-end-8">
              <div class="chart-container">
                <ion-grid class="ion-no-padding">
                  <ion-row class="ion-justify-content-center">

                    <ion-col size="12" class="ion-padding-5">
                      <swiper-container #chartsCarousel init="false" class="mySwiper ion-over-visible-content">
                        @for ( chart of chartsDetail; track chart; let idx = $index ) {
                        <swiper-slide>
                          <img [alt]="'Etiqueta._Graficas' | translate" [src]="chart" class="maximixed-img-chart-ai box-clickable"
                            (click)="onOpenImageSwiperModal(idx)" />
                        </swiper-slide>
                        }
                      </swiper-container>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </div>
            </div>
            }
            }

            @if (maximixedModalView() === "ChartsMinitures") {
            @if (chartsDetail.length > 0) {
            <div class="ion-padding-start-8 ion-padding-end-8">
              <div class="box-chart-container">
                <ion-grid class="ion-no-padding">
                  <ion-row class="ion-justify-content-center">
                    @for ( chart of chartsDetail; track chart; let idx = $index ) {
                    <ion-col size="4" class="ion-padding-3">
                      <div class="chart-container">
                        <img [alt]="'Etiqueta._Graficas' | translate" [src]="chart" class="img-chart-ai box-clickable" (click)="onOpenImageSwiperModal(idx)" />
                      </div>
                    </ion-col>
                    }
                  </ion-row>
                </ion-grid>
              </div>
            </div>
            }
            }
          </ion-list>
        </ion-col>
      </ion-row>
      }
    </ion-grid>
  </div>
</div>
}